import React, { useEffect, useMemo, useState, useCallback } from "react";
import { Autocomplete } from "@mui/material";
import { CircularProgress, FormControl, InputLabel } from "@mui/material";
import {
  Box,
  MenuItem,
  Select,
  TextField,
  styled,
  Grid,
  Button,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { Toast } from "../components/Toast";
import dustbin from "../../images/dustbin.png";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ItemHistory from "./ItemHistory";
import Repo from "../../Repository/Repo";
import { useDispatch, useSelector } from "react-redux";
import {
  addToSelected,
  editSelected,
  toRemoveItem,
  payValue,
  totalPurchaseAmount,
  increasePurchaseQty,
} from "./purchaseSlice";
import { getItems } from "../inventory/itemsSlice";
import BarcodeReader from "react-barcode-reader";
import DefaultRepository from "../../Repository/DefaultRepository";
import AddBatchNo from "./AddBatchNo";
const MainStyle = styled(Box)({
  background: "#fff",
  padding: "4px 0px",
  maxHeight: "86vh",
  overflow: "auto",
  borderRadius: "4px",
});

function ItemsTable({ ledger }) {
  const dispatch = useDispatch();
  const { items } = useSelector((state) => state.purchase);
  console.log("items", items);
  const { pay } = useSelector((state) => state.purchase);
  const inventory = useSelector((state) => state.inventory.items);

  const [searchItem, setSearchItem] = useState("");
  const [selected, setSelected] = useState(null);
  const [modal, setModal] = useState(false);
  const [searched, setSearched] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [barCodeLoading, setBarCodeLoading] = useState(false);
  const [barcode, setBarcode] = useState(false);
  const [batchModal, setBatchModal] = useState(false);
  const [checked, setChecked] = useState(false);

  // const [pay, setPay] = useState(0);
  console.log("paypay", pay);
  // const [items, setItems] = useState([]);
  console.log("itmes", items);
  const handleRemove = (_id, i) => {
    dispatch(toRemoveItem(_id));
    // let copy = [...items];
    // copy.splice(i, 1);
    // setItems(copy);
  };
  useEffect(() => {
    if (inventory.length == 0) {
      dispatch(getItems());
    }
  }, []);

  let myTotal = 0;
  useEffect(() => {
    console.log("purchase", myTotal);
    dispatch(totalPurchaseAmount(myTotal));
  }, [myTotal, dispatch]);

  const fetchBarCode = async (value) => {
    let { data } = await DefaultRepository.defaultModel({
      request: {
        method: "getItemByBarCode",
        data: {
          company_code: localStorage.getItem("companyCode"),
          barCode: value,
        },
      },
    });
    let item = data.response.data.item;
    if (data.response.data.item) {
      item.saleQuantity = 1;
      dispatch(addToSelected(item));
    } else {
      Toast("info", "Item Not Found");
    }
    setBarCodeLoading(false);
  };

  const handleSearch = (e, val) => {
    setSearchItem(val);
  };

  const toggle = () => {
    setOpen((prev) => !prev);
  };

  const handleChecked = (event) => {
    setChecked(event.target.checked);
    if (event.target.checked) {
      setBatchModal((prev) => !prev);
    }
  };

  const handleChange = (e, index, pack) => {
    let { name, value } = e.target;
    // let copy = [...items];
    // copy[index][name] = value;
    // setItems(copy);
    console.log("valll", value);
    if (name == "pay") {
      // setPay(value);
      dispatch(payValue(value));
    }
    let steelWeightKgSale;
    if (pack) {
      steelWeightKgSale = Number(value) * Number(pack);
    }
    console.log("valllll", value);
    console.log("pack", pack);
    console.log("   steelWeightKgSale ", steelWeightKgSale);

    dispatch(editSelected({ name, value, index, steelWeightKgSale }));
  };
  const onSelect = (item) => {
    if (typeof item === "object" && item !== null) {
      // setItems((prev) => [...prev, item]);
      dispatch(addToSelected(item));
      setSearchItem("");
      setSearched([]);
    }
  };
  // const handleBatch = (e, item) => {
  //   console.log("eeeee", e);
  //   console.log("itemmm", item);

  //   const batch = e;
  //   // const value = e.target.value;
  //   // console.log('valuee', value)
  //   dispatch(editSelected({ batch, index: item }));
  //   handleModel();
  // };

  const handleBatch = (e, i) => {
    console.log("eeeee", e);
    console.log("iiiiii", i);

    const batch = e;
    // const value = e.target.value;
    // console.log('valuee', value)
    // dispatch(editSelected({ batch, index: item }));
    dispatch(editSelected({ value: e, index: i, name: "batchNo", batch }));

    handleModel();
  };

  const scanItem = useCallback(
    (value) => {
      console.log("dis", value);
      setBarCodeLoading(true);
      let found = "";
      let serverFound = "";
      // found = items.find((item) => Number(item?.barCode?.toString().trim()) === Number(value.toString().trim()));
      found = items.find((item) => {
        console.log("itemmmmmmm", item);
        return (
          Number(item?.barCode?.toString().trim()) ===
          Number(value.toString().trim())
        );
      });
      console.log("items", items);

      console.log("found", found);
      console.log("value", value);

      if (found) {
        console.log("founded");
        setBarcode(true);
      }

      if (found) {
        console.log("foundedddif");
        setBarCodeLoading(false);
        dispatch(increasePurchaseQty(found));
      } else {
        console.log("foundedddelse");
        serverFound = items.find((item) => Number(item?.barCode) == value);
        console.log("serverfoun", serverFound);
        if (serverFound) {
          setBarCodeLoading(false);
          dispatch(increasePurchaseQty(serverFound));
        } else {
          fetchBarCode(value);
        }
      }
    },
    [dispatch, inventory, items]
  );

  const foundBatch = useMemo(() => {
    let found = items.find((item) => {
      if (item?.batchNumber && item?.batchNumber.length > 0) {
        return item;
      }
    });
    if (found) {
      return true;
    } else {
      return false;
    }
  }, [items]);

  const historyToggle = (item = null) => {
    if (item && !ledger) {
      Toast("info", "Kindly select a ledger");
      return;
    }
    setSelected(item);
    setModal((prev) => !prev);
  };

  const getSearchItems = async () => {
    try {
      setLoading(true);
      let { data } = await Repo.default({
        request: {
          method: "getSearchItems",
          data: {
            company_code: localStorage.getItem("companyCode"),
            search_item: searchItem,
            vendor: "",
          },
        },
      });
      setOpen(true);
      let res = data.response.data.items;
      setLoading(false);
      if (res.length > 0) {
        setSearched(res);
      } else {
        Toast("info", "No Items Found");
      }
    } catch (err) {
      console.log("err:", err);
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key == "Enter" && searchItem) {
      getSearchItems();
    }
  };

  const handleModel = () => {
    setBatchModal((prev) => !prev);
  };
  const handleOnScan = useCallback(
    (e) => {
      if (!barCodeLoading) {
        console.log("not");
        scanItem(e);
      }
    },
    [barCodeLoading, scanItem]
  );

  const handleError = useCallback((err) => {
    console.log("err");
  }, []);

  return (
    <Box>
      <BarcodeReader onScan={handleOnScan} onError={handleError} />

      <MainStyle>
        {[...items, {}].map((item, i) => {
          console.log("item", item);
          console.log("iiiiii", i);

          let newQty = item.newQuantity || 1;
          let price = item.newPrice
            ? parseFloat(item.newPrice)
            : parseFloat(item.companyPrice);
          let saleDiscount = item.saleDiscount;
          let finalPrice = newQty * price;
          console.log("final", finalPrice);
          let dis = 0;
          if (saleDiscount) {
            dis = (saleDiscount / 100) * finalPrice;
            finalPrice -= dis;
          } else {
            saleDiscount = 0;
          }
          console.log("dis", dis);
          console.log("price", price);

          myTotal = Math.ceil(myTotal + newQty * price - dis) || 0;
          console.log("sale", myTotal);
          return (
            <Box key={i} sx={{ py: "4px", borderRadius: "4px", width: "100%" }}>
              <Grid
                container
                rowSpacing="16px"
                sx={{ width: "100%", px: "4px" }}
              >
                <Grid
                  item
                  md={3.7}
                  sm={6}
                  xs={12}
                  sx={{ display: "flex", px: "2px" }}
                >
                  {/* {item?._id && (
                    <TextField
                      fullWidth
                      size="small"
                      label="Item"
                      name="searchItem"
                      value={item.name}
                      disabled
                    />
                  )} */}

                  {
                    <Autocomplete
                      size="small"
                      fullWidth
                      value={item}
                      // onChange={(e, val) => {
                      //   handleItem(e, val);
                      // }}
                      onChange={(event, newValue) => {
                        onSelect(newValue);
                      }}
                      getOptionLabel={(option) => option?.name || ""}
                      id="controllable-states-demo"
                      options={inventory}
                      renderInput={(params) => (
                        <TextField
                          placeholder={"Select An Item"}
                          {...params}
                          fullWidth
                          variant="outlined"
                          size="small"
                        />
                      )}
                    />
                  }
                  {/* {!item?._id && (
                    <Autocomplete
                      // value={searchItem}
                      onChange={(event, newValue) => {
                        onSelect(newValue)
                      }}
                      onKeyDown={handleKeyDown}
                      inputValue={searchItem}
                      onInputChange={(e, newInputValue) => {
                        handleSearch(e, newInputValue);
                      }}
                      fullWidth
                      size="small"
                      freeSolo
                      disableClearable
                      options={searched}
                      open={open}
                      onOpen={toggle}
                      onClose={toggle}
                      getOptionLabel={(option) => option?.name || ""}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="search Item..."
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {loading ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                  )} */}
                </Grid>

                {item?._id && (
                  <Grid
                    item
                    md={foundBatch ? 1 : 1.5}
                    sm={3}
                    xs={6}
                    sx={{ px: "2px" }}
                  >
                    <TextField
                      fullWidth
                      variant="outlined"
                      label="Disc%"
                      type="number"
                      size="small"
                      sx={{ mx: "2px" }}
                      name="saleDiscount"
                      value={item.saleDiscount || ""}
                      onChange={(e) => handleChange(e, i)}
                    />
                  </Grid>
                )}
                {item?._id && foundBatch && (
                  <Grid item md={1.5} sm={3} xs={6} sx={{ px: "2px" }}>
                    <FormControl size="small" fullWidth>
                      <InputLabel>Batch #</InputLabel>
                      <Select
                        fullWidth
                        variant="outlined"
                        value={item?.batchNo || ""}
                        label="Batch #"
                        name="batchNo"
                        onChange={(e) => handleChange(e, i)}
                      >
                        <MenuItem value="">None</MenuItem>
                        {item?.batchNumber &&
                          item?.batchNumber?.map((item, ind) => {
                            return (
                              <MenuItem key={ind} value={item.batchNumber}>
                                {item.batchNumber}
                              </MenuItem>
                            );
                          })}
                      </Select>
                    </FormControl>
                  </Grid>
                )}
                {item?._id && (
                  <Grid
                    item
                    md={foundBatch ? 1 : 1.5}
                    sm={3}
                    xs={6}
                    sx={{ px: "2px" }}
                  >
                    <TextField
                      disabled
                      variant="outlined"
                      label="Qty"
                      fullWidth
                      size="small"
                      value={(item.purchaseType == "box" ? item.totalBoxes : (item?.weight || item?.quantity || 0))}
                    />
                  </Grid>
                )}

                {item?._id && (
                  <Grid
                    item
                    md={foundBatch ? 1 : 1.5}
                    sm={3}
                    xs={6}
                    sx={{ px: "2px" }}
                  >
                    <TextField
                      fullWidth
                      type="number"
                      size="small"
                      variant="outlined"
                      label="New Qty"
                      max={item?.quantity}
                      name="newQuantity"
                      value={newQty}
                      onChange={(e) => handleChange(e, i, item?.steelWeightKg)}
                    />
                  </Grid>
                )}

                {item?._id && (
                  <Grid item md={1.5} sm={3} xs={6} sx={{ px: "2px" }}>
                    <TextField
                      type="number"
                      size="small"
                      fullWidth
                      label="U Price"
                      variant="outlined"
                      name="newPrice"
                      value={item.newPrice ? item.newPrice : item.companyPrice}
                      onChange={(e) => handleChange(e, i)}
                    />
                  </Grid>
                )}

                {item?._id && (
                  <Grid item md={1.5} sm={5} xs={10} sx={{ px: "2px" }}>
                    <TextField
                      size="small"
                      disabled
                      fullWidth
                      variant="outlined"
                      label="Total"
                      value={
                        finalPrice % 1 === 0
                          ? finalPrice
                          : finalPrice.toFixed(3)
                      }
                    />
                  </Grid>
                )}
                {item?._id && (
                  <Grid
                    item
                    md={0.8}
                    sm={1}
                    xs={2}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    {ledger && (
                      <VisibilityIcon
                        sx={{ color: "#333333", cursor: "pointer", mr: "4px" }}
                        onClick={() => historyToggle(item)}
                      />
                    )}
                    <img
                      height="25px"
                      style={{ cursor: "pointer" }}
                      src={dustbin}
                      alt="img"
                      onClick={() => handleRemove(item._id, i)}
                    />

                    {/* <FormControlLabel
                      control={
                        <Checkbox checked={checked} onChange={handleChecked} />
                      }
                      label=""
                    /> */}
                  </Grid>
                )}

                {/* {item?.box == true && (
                  <Grid  md={4}
>
                <FormControl sx={{width:"100%"}}>
                      <InputLabel id="sale-type-label">Sale Type</InputLabel>
                      <Select
                        labelId="sale-type-label"
                        id="sale-type"
                        name="purchaseType"
                        value={item?.saleType}
                        label="Purchase Type"
                        onChange={(e) => handleChange(e, i)}
                        >
                        <MenuItem value="box">
                          {item.saleLabel == "box" ? "By Box" : "By Ctn"}
                        </MenuItem>
                        <MenuItem value="pieces">
                          {item.saleLabel == "box" ? "By Pieces" : "By Box"}
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                )} */}

                {/* {item?._id && (
                  <Grid item md={1.5} sm={5} xs={10} sx={{ px: "2px" }}>
                    <Button
                      height="25px"
                      style={{ cursor: "pointer", backgroundColor: "green" }}
                      onClick={() => handleRemove(item._id, i)}
                    />
                  </Grid>
                )} */}

                {/* {item?.batchNumber?.length > 0 && (
                  <Button
                    variant="contained"
                    sx={{ maxWidth: "2rem", height: "2rem" }}
                    onClick={() => handleModel()}
                  >
                    Batch
                  </Button>
                )} */}

                {item.steelWeightKg && item.steelWeightKg > 0 ? (
                  <TextField
                    value={
                      Number(item?.steelWeightKg) *
                      Number(item.newQuantity || 1)
                    }
                    // placeholder={isMdDown ? "Total" : ""}
                    size="small"
                    disabled
                    label="Total Weight (Kg)" // Add a label
                    // onChange={(e) => handleEdit(e, i, "steelWeightKgSale")}
                  />
                ) : null}

                {batchModal && (
                  <AddBatchNo
                    onClose={() => handleModel()}
                    onSuccess={(e) => handleBatch(e, i)}
                  />
                )}
              </Grid>
            </Box>
          );
        })}
      </MainStyle>

      {modal && (
        <ItemHistory onClose={historyToggle} item={selected} ledger={ledger} />
      )}
    </Box>
  );
}

export default ItemsTable;
